import React from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      window.scrollTo({
        top: section.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <footer className="bg-dark text-white py-2 pb-3">
      <Row className="d-flex justify-content-between align-items-center mx-2">
        {/* Left Section: Copyright Text */}
        <Col className="text-start mt-2">
          <p>&copy; 2025 AI Powered CV Maker. All Rights Reserved.</p>
        </Col>

        {/* Right Section: Links */}
        <Col className="text-end">
          <div>
            <span
              className="text-white mx-3 text-decoration-none"
              onClick={() => scrollToSection("terms")}
              style={{ cursor: "pointer" }}
            >
              Privacy Policy & Terms of Service
            </span>
            <span
              className="text-white mx-3 text-decoration-none"
              onClick={() => navigate("/contact")}
              style={{ cursor: "pointer" }}
            >
              Contact
            </span>
          </div>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
